import React, { useEffect } from 'react';
import { Grid, Box, Link } from '@mui/material';
import CustomTextField from '../../../../components/CustomTextField/CustomTextField';

type CertificationsFieldProps = {
  certifications?: {
    certification: string;
  }[];
};
const CertificationsField = (props: CertificationsFieldProps) => {
  const { certifications } = props;

  const [certificationsValue, setCertificationsValue] = React.useState(
    certifications || []
  );

  useEffect(() => {
    setCertificationsValue(certifications || []);
  }, [certifications]);

  return (
    <Grid display={'flex'} gap={5} flexDirection={'column'} p={5}>
      <Grid item xs={12} sm={6} display={'flex'} flexDirection={'column'}>
        <label
          htmlFor='certifications'
          style={{
            fontWeight: 700,
            fontSize: '18px',
            color: '#000000',
            marginLeft: '10px',
          }}>
          Certifications
        </label>
        {certificationsValue?.map((certification, index) => (
          <Grid key={index} display={'flex'} alignItems={'center'} flex={1}>
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                gap: 1,
                alignItems: 'center',
              }}>
              <CustomTextField
                name='certifications'
                sx={{ width: '100%', maxWidth: '654px' }}
                value={certification?.certification || ''}
                // defaultValue={"firstName" || ""}
                // onChange={function (
                //   e: React.ChangeEvent<HTMLInputElement>
                // ): void {
                //   setCertificationsValue((prev) => {
                //     const newCertifications = [...prev];
                //     newCertifications[index].certification = e.target.value;
                //     return newCertifications;
                //   });

                //   // throw new Error("Function not implemented.");
                // }}
                onChange={() => {}}
              />
              <Link
                color={'##000000'}
                sx={{ color: '#000000', fontSize: '17px', fontWeight: 400 }}>
                Add a Certifications
              </Link>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default CertificationsField;
